module.exports = __webpack_public_path__ + "img/monitor.20a26416.png";